/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { ActionIcon, rem, useMantineTheme, type ActionIconProps } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

import Paths from '@fai/friendli-suite/features/routes/paths';
import { FriendliLogoIcon } from '@fai/svgr';

export default function SuiteLogo({
  path,
  style,
  size = 40,
}: {
  path?: string;
  style?: ActionIconProps['style'];
  size?: number;
}) {
  const navigate = useNavigate();
  const theme = useMantineTheme();

  return (
    <ActionIcon
      c={theme.pf.color.fg.neutral.strong}
      size={rem(size)}
      style={{ ...style, transition: 'all 0.125s ease-in-out' }}
      onClick={() => navigate(path ?? Paths.defaultTeam.default)}
    >
      <FriendliLogoIcon size={size} style={{ transition: 'all 0.125s ease-in-out' }} />
    </ActionIcon>
  );
}

SuiteLogo.displayName = 'SuiteLogo';
